import React, { FC } from 'react'
import useFormProcessor from '@hooks/useFormProcessor'
import useRiskMapJobPositions from '@hooks/useRiskMapJobPositions'
import ListPage from '@templates/ListPage'
import PositionAndDangersModal from '@modals/PositionAndDangersModal'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import PositionAndDangers from './PositionAndDangers'

const WorkPlaces: FC = () => {
  const methods = useFormProcessor()
  const { data, ...rest } = useRiskMapJobPositions({
    initOrder: {
      order: {
        title: SortStates.ASC,
      },
    },
  })
  const { items = [], length = 0 } = data || {}

  return (
    <ListPage
      {...rest}
      titleTabs={[
        {
          title: 'Должности и опасности',
          counter: length,
          index: 0,
        },
      ]}
      ModalContent={PositionAndDangersModal}
      methods={methods}
      ItemComponent={PositionAndDangers}
      list={items}
      length={length}
      withSearch
      searchFilterName="simpleSearch"
    />
  )
}

export default WorkPlaces
